import { queryClient } from "@/base/libs/react-query";
import { projectApi } from "@/service/client";
import { Project } from "@/shared/model/project.model";
import { useQuery } from "@tanstack/react-query";
import { useAtom } from "jotai";
import { atomWithStorage } from "jotai/utils";
import { useEffect } from "react";

const selectedProjectAtom = atomWithStorage<Project | null>(
  "selected-project",
  null
);

export const useProjectController = () => {
  const [selectedProject, setSelectedProject] = useAtom(selectedProjectAtom);

  const { data: projectList } = useQuery({
    queryKey: ["projects"],
    queryFn: () => projectApi.list(),
  });

  useEffect(() => {
    if (projectList && projectList.length > 0 && selectedProject === null) {
      setSelectedProject(projectList[0]);
    }
  }, [projectList]);

  const createProject = async (name: string): Promise<Project> => {
    const project = await projectApi.create({ name });
    queryClient.invalidateQueries({ queryKey: ["projects"] });
    return project;
  };

  const onSelectProject = (project: Project) => {
    setSelectedProject(project);
  };

  return { projectList, createProject, selectedProject, onSelectProject };
};
